import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatusesEnum } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'documentStatus',
  pure: true
})
export class DocumentStatusPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: DocumentStatusesEnum): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getDocumentStatusName(value, language);
  }
}
